import React from 'react';
import styled, {css} from 'styled-components';
import ContactForm from './ContactForm';
import {H2} from '../../atoms/TextComponents';
import {Col, Grid, Row} from 'react-styled-flexboxgrid';
import {getColors, maxMediaQueries} from '../../utils/styling';
import {Button, ExternalLinkButton} from '../../atoms/Button';
import {GlobalContext} from '../../context/GlobalContext';
import CTABg from '../../../assets/backgrounds/cta_background.svg';

const CTABlockSection = styled.section`
  margin: 64px 0;
`;

const CTABlockContainer = styled.div`
  
  > div {
    border-radius: 4px;
    padding: 64px 88px;
    ${({theme}) => css`background-color: ${getColors(theme).gray800}`};
    background-image: url(${CTABg});
    background-repeat: no-repeat;
    background-position: right center;
    background-size: contain;
    
    button {
      margin: 24px 0 0 0;
    }
    
  .no-gutter {
    padding: 0;
  }
    
   ${maxMediaQueries.md`
      background-image: none;
   `};
   
   ${maxMediaQueries.sm`
      padding: 32px 24px;
   `};
   
  }
`;

const CTABlock = ({title}) => (
    <CTABlockSection>
      <Grid>
        <CTABlockContainer>
          <Row>
            <Col className="no-gutter" xs={12} sm={7}>
              <H2 color="gray100">{title}</H2>
              {/* TODO discuss link */}
              <GlobalContext.Consumer>
                {globalContext =>
                    <ExternalLinkButton primary href="https://www.dixa.com/demo">Book a Demo</ExternalLinkButton>
                }
              </GlobalContext.Consumer>
            </Col>
          </Row>
        </CTABlockContainer>
      </Grid>
    </CTABlockSection>
);

export default CTABlock;
